import React, {useState} from 'react';
import {tooltips as TTS} from '../../../../_common/constants/tooltips';
import {can} from '../../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../../_common/constants/permissionSubjects';
import FormChangeFileName from '../FormChangeFileName';
import ButtonAction from '../../../../_common/components/ButtonAction';
import ModalContainer from '../../../../_common/components/ModalContainer';

const ButtonEditFileName = ({fileID, fileName}) => {
  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        title={TTS.EDIT_INSPECTION}
        disabled={!can(T.FULL, S.OLD_INSPECTION_DETAILS_PAGE)}
        onClick={handleOpen}
        label={<img src={'../../../media/common/Edit_primary.svg'} alt="edit"/>}
      />
      <ModalContainer show={show} onClose={handleClose} size={'md'}>
        <FormChangeFileName fileID={fileID} onClose={handleClose} fileName={fileName}/>
      </ModalContainer>
    </>
  );
};

export default ButtonEditFileName;